<template>
  <button
    @click="withConfirm"
    title="Pause/Stop recording"
    v-tippy><font-awesome-icon :icon="faStop" /></button>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faStop } from '@fortawesome/pro-light-svg-icons/faStop'
  import { createNamespacedHelpers } from 'vuex'
  import swal from 'sweetalert2'

  const { mapActions, mapState } = createNamespacedHelpers('conference')

  export default {
    components: {
      FontAwesomeIcon
    },
    data () {
      return {
        faStop,
        swalStopErrorData: {
          type: 'error',
          text: 'Sorry, recording could not be stopped. Please try again.',
          confirmButtonText: 'OK',
          confirmButtonColor: ' #f0415a',
          showCloseButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        },
        swalPauseErrorData: {
          type: 'error',
          text: 'Sorry, recording could not be paused. Please try again.',
          confirmButtonText: 'OK',
          confirmButtonColor: ' #f0415a',
          showCloseButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        }
      }
    },
    computed: mapState([
      'activity',
      'recordingButtonDisabled'
    ]),
    methods: {
      ...mapActions([
        'stopRecording',
        'pauseRecording',
        'markRecordingState',
        'markRecordingButtonDisabled'
      ]),
      withConfirm () {
        swal({
          titleText: 'Are you sure?',
          type: 'warning',
          text: `Would you like to pause or delete the recording? If you Delete recording, the recording will be permanently
           deleted and not available for listening back. If you Pause, you can resume recording again
           if you wish, and the recording will be available in Playback.`,
          showCancelButton: true,
          confirmButtonColor: ' #f0415a',
          confirmButtonText: 'Pause',
          cancelButtonText: 'Delete',
          showCloseButton: true
        }).then((result) => {
          if (result.value) {
            this.markRecordingButtonDisabled(true)
            this.pauseRecording(this.swalPauseErrorData)
          } else if (result.dismiss === swal.DismissReason.cancel) {
            this.markRecordingButtonDisabled(true)
            this.stopRecording(this.swalStopErrorData)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// recording-pause-stop-button.vue?dfb66786